<template>

    <div class="container px-3 mx-auto md:px-10 pb-2 pt-10">


        <div v-if="filter">
            <SearchComponent />
            <div class="mt-3 px-5">
                <FilterComponent v-if="filter" :meta="meta" :data="data" @submit="search" />
            </div>

        </div>

        <TourPaginator :data="data" :loading="loading" :tours="ssrData?.tours"
            :pagination="ssrData?.pagination" @filtered="filtered"
            @order_change="(value?: string) => search({ order_by: value })" />
    </div>

</template>


<script setup lang="ts">


import FilterComponent from "@/Components/Tour/Filter.vue";
import SearchComponent from "@/Components/Tour/Search.vue";
import TourPaginator from "@/Components/Tour/TourPaginator.vue";
import { ref } from "vue";
import { router, usePage } from "@inertiajs/vue3";
import useAgency from "@/Hook/useAgency";
import { Pagination, Tour } from "@/types";


const { ssrData } = defineProps<{
    filter?: boolean;
    // Server-resolved listing payload, injected by ShortcodeResolver for the
    // `[tour-listing]` shortcode so the paginator renders during SSR.
    ssrData?: { tours?: Tour[]; pagination?: Pagination; meta?: any };
}>()

const meta = ref(ssrData?.meta ?? {})
const data = ref(usePage().props.__params);
const loading = ref(false);


const reseller = useAgency()


const search = function (data: { [key: string]: any }, reset = false) {
    loading.value = true;

    if (reseller.hasAgency.value) {
        data['agency_id'] = reseller.agencyId.value;
        data['agent_id'] = reseller.agent.value
    }
    router.get(location.pathname,
        reset ? {} : { ...data, filter: 'true' },
        {
            onFinish: function () {
                loading.value = false;
            }
        }
    )
}


const filtered = function (data: any) {
    meta.value = data.meta
}

</script>